import {BillingPlan, DigiknowOrgType} from '../../../ext/lib/types';

export type AdBillingOrg = {
  organizationType: DigiknowOrgType,
  billingPlan: BillingPlan
}

/** Summarize the organization type and billing for display on ad invoices */
export function displayType(org: AdBillingOrg): string {
  const {organizationType, billingPlan} = org;
  if (organizationType === 'Campus Department' && billingPlan === 'quarterly') {
    return 'Campus Department Quarterly Plan';
  } else if (organizationType === 'Campus Department' && billingPlan === 'per-ad') {
    return 'Campus Department \u2014 One Ad for 7 Days';
  } else if (organizationType === 'Campus Department w/ Sponsorship Logo' && billingPlan === 'quarterly') {
    return 'Campus Department Quarterly Plan with Sponsorship Logo(s)';
  } else if (organizationType === 'Campus Department w/ Sponsorship Logo' && billingPlan === 'per-ad') {
    return 'Campus Department \u2014 One Ad for 7 Days with Sponsorship Logo(s)';
  } else if (organizationType === 'Registered Student Group' && billingPlan === 'quarterly') {
    return 'Student Organization \u2014 Quarterly Plan';
  } else if (organizationType === 'Registered Student Group' && billingPlan === 'per-ad') {
    return 'Student Organization \u2014 One Ad for 7 Days';
  } else {
    return 'Housing/Residential Dining'
  }
}

/** Determine whether an ad must be prepaid before it is displayed */
export function isPrepay(orgType: DigiknowOrgType): boolean {
  return orgType === 'Registered Student Group' as DigiknowOrgType;
}

/** Determine whether ad payment is recharged */
export const isRecharge: (_: DigiknowOrgType) => boolean =
  type =>
    ['Campus Department', 'Campus Department w/ Sponsorship Logo'].indexOf(type) >= 0;
